import { InjectionToken, Provider } from '@angular/core';

/**
 * LU wrapper options for CK editor
 */
export interface LuCkeditorOptions {
	/**
	 * CK editor width
	 */
	width: string;

	/**
	 * CK editor height
	 */
	height: string;

	/**
	 * NOTE: SHOULD BE REMOVED (skipping for now as it require a lot of refactoring)
	 * Hide table button in tool bar (button is currently added to all toolbars by default)
	 */
	hideTableOption: boolean;

	/**
	 * Destroys all other ck editor instances
	 */
	clearAllPreviousInstances: boolean;

	/**
	 * @deprecated will be removed at a later date
	 * Use toolbar instead to include specific toolbar action
	 *
	 * Enables toolbar preset with
	 * clipboard - ['Undo', 'Redo']
	 * styles - ['Format']
	 * basicstyles - ['Bold', 'Italic', 'Underline', '-', 'Link', 'Unlink', '-', 'Subscript', 'Superscript']
	 * paragraph - ['NumberedList', 'BulletedList', '-', 'Blockquote', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', '-', 'MediaEmbed']
	 * insert - items: ['djimage']
	 */
	toolbarForForums: boolean;

	/**
	 * @deprecated will be removed at a later date
	 * Use toolbar instead to include specific toolbar action
	 *
	 * Enables toolbar preset with
	 * clipboard - ['Undo', 'Redo']
	 * basicstyles - ['Bold', 'Italic', 'Underline', '-', 'Link', 'Unlink', '-', 'Subscript', 'Superscript']
	 */
	toolbarForPostComments: boolean;

	/**
	 * @deprecated will be removed at a later date
	 * Use toolbar instead to include specific toolbar action
	 *
	 * Enables toolbar preset with
	 * clipboard - ['Undo', 'Redo']
	 * basicstyles - ['Bold', 'Italic', 'Underline', '-', 'Link', 'Unlink', '-', 'Subscript', 'Superscript']
	 * styles - ['Format', 'Font', 'FontSize']
	 * colors - ['TextColor', 'BGColor']
	 * paragraph - ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock', 'HorizontalRule']
	 * basicstyles - ['Bold', 'Italic', 'Underline', 'Subscript', 'Superscript', '-', 'Link', 'Unlink']
	 * advanced - ['Preview', 'Maximize']
	 */
	toolbarForSessionDescription: boolean;

	/**
	 * @deprecated will be removed at a later date
	 * Use toolbar instead to include specific toolbar action
	 *
	 * Adds djimage plugin
	 */
	addImageUploadViaDj: boolean;

	/**
	 * In combination with addImageUploadViaDj removes image plugin (have no idea why)
	 * if (options.addImageUploadViaDj && options.disableImageProperties) {
	 * 	removePlugin = [...removePlugin, 'image'];
	 * }
	 */
	disableImageProperties: boolean;

	addImageUpload: boolean;

	/**
	 * @deprecated will be removed at a later date
	 * Use plugins instead to include specific plugins
	 */
	addEmbeddedMedia: boolean;

	/**
	 * @deprecated will be removed at a later date
	 * Use plugins instead to include specific plugins
	 */
	addMathJax: boolean;

	/**
	 * @deprecated will be removed at a later date
	 * Use plugins instead to include specific plugins
	 */
	addInsertSymbols: boolean;

	/**
	 * @deprecated will be removed at a later date
	 * Use plugins instead to include specific plugins
	 */
	addBlankPlaceholder: boolean;

	/**
	 * CK editor body class
	 */
	bodyClass: string;

	/**
	 * CK editor format tags
	 * eg. p;h1;h2;h3;h4;h5;h6;pre;address;div"
	 */
	formatTags: string;

	/**
	 * Set input disabled state
	 */
	disabled?: boolean;

	/**
	 * Array of plugins to activate (ones located in js files)
	 * plugin names only
	 */
	plugins?: string[];

	/**
	 * Array of custom plugins to activate
	 * (not ones located in js files)
	 */
	customPlugins?: LuCkEditorCustomPlugin[];

	/**
	 * Array of plugins to remove
	 */
	pluginsForRemoval?: string[];

	/**
	 * Array of actions to be added to toolbar
	 * Should be avoided, better use toolbar option
	 */
	// TODO: rethink
	insertInToolbar?: string[];

	/**
	 * Toolbar actions preset (ones located in js files)
	 * Accepts eg. { name: 'colors', items: ['TextColor', 'BGColor'] } or '/'(for break to new row)
	 */
	toolbar?: (LuCkEditorToolBar | string)[];

	/**
	 * Register custom on change callback method
	 */
	editorTextChangeEvent?: () => void;

	/**
	 * Register custom on ready callback method
	 */
	onReady?: () => void;

	/**
	 * Initial CK editor content value (comes from Formly wrapper)
	 */
	value: string;

	executeDjImageUpload?: () => void;
}

export interface LuCkeditorRootConfig {
	dynamicScriptLoader: Provider;
}

export interface CkEditorDynamicScriptLoaderServiceInterface {
	instancesIds: Array<any>;
	load: (...scripts: Array<string>) => Promise<any>;
}

export const DYNAMIC_SCRIPT_LOADER_INJECTION_TOKEN = new InjectionToken('DYNAMIC_SCRIPT_LOADER_INJECTION_TOKEN');

export interface LuCkEditorToolBar {
	/**
	 * Toolbar name
	 */
	name: string;
	/**
	 * Toolbar actions
	 */
	items: string[];
}
/**
 * CK editor internal options interface
 */
export interface LuInternalCkEditorOptions {
	toolbar: (LuCkEditorToolBar | string)[];
	extraPlugins: string;
	bodyClass: string;
	format_tags: string;
	removeDialogTabs: string;
	width?: string;
	height?: string;
	removePlugins?: string;
	linkShowAdvancedTab?: boolean;
	[K: string]: any;
}

/**
 * Custom CK editor plugin
 * Not located in js files
 */
export interface LuCkEditorCustomPlugin {
	name: string;
	beforeInit?: (editor) => void;
	init?: (editor) => void;
	[K: string]: any;
}
